import React, { Component } from 'react';
import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { API_ROOT } from '../../../api/Routes';

const ModalContent = styled.div`
  background-color: #fff;
  margin: auto;
  height: fit-content;
  max-height: 90vh;
  min-width: 400px;
  max-width: 1024px;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.3);

  &:focus {
    outline: 0;
  }
`;

const ModalHeader = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
`;

const ModalBody = styled.div`
  padding: 0 16px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  display: block;
`;

class PreviewImageModal extends Component {
  handleDownload = () => {
    const link = document.createElement('a');
    link.href = `${API_ROOT}/asset/${this.props.image}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    const { open, onClose, image } = this.props;

    return (
      <Modal
        aria-labelledby="preview-image"
        aria-describedby="modal for previewing images"
        open={open}
        onClose={onClose}
      >
        <ModalContent>
          <ModalHeader>
            <Typography variant="h4">Image Preview</Typography>
            <span>
              <Button
                onClick={onClose}
                variant="contained"
                style={{ marginRight: '16px' }}
              >
                Cancel
              </Button>
              <Button
                onClick={this.handleDownload}
                variant="contained"
                color="primary"
              >
                Download
              </Button>
            </span>
          </ModalHeader>
          <ModalBody>
            <Image src={`${API_ROOT}/asset/${image}`} alt="preview" />
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  }
}

export default PreviewImageModal;
